import { divide } from "lodash";
import React, { useEffect, useState } from "react";
import DialogConfirm from "../Shared/DialogInfoGeneral";

const BrowserNeedUpdate: React.FC = () => {
  const [isUnsupported, setIsUnsupported] = useState(false);

  useEffect(() => {
    const isBrowserOutdated = () => {
      const userAgent = navigator.userAgent;
      const unsupportedBrowsers = [
        { name: "MSIE", version: 11 },
        { name: "Trident", version: 7 }, // IE 11
        { name: "Edge", version: 16 }, // Edge Legacy
        { name: "Chrome", version: 70 },
        { name: "Firefox", version: 60 },
        { name: "Safari", version: 11 },
      ];

      for (let browser of unsupportedBrowsers) {
        const regex = new RegExp(`${browser.name}/([0-9]+)`);
        const match = userAgent.match(regex);
        if (match && parseInt(match[1]) <= browser.version) {
          return true;
        }
      }

      return false;
    };

    if (isBrowserOutdated()) {
      setIsUnsupported(true);
    }
  }, []);

  return (
    <div>
      <DialogConfirm
        show={isUnsupported}
        disabledFooter={true}
        disabledClosable={true}
        closeDialog={() => null}
      >
        <div className="px-10 text-xl opensans text-center py-10">
          Tu navegador no es compatible con esta aplicación. 
          <div className="py-10">
            Por favor, actualiza tu navegador para una mejor experiencia.
          </div>
        </div>
      </DialogConfirm>
    </div>
  );
};

export default BrowserNeedUpdate;
